import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {ConsultationSummaryModel} from '../consultationSummary.model';
import {
    ConsultationCategorySummaryConverter
} from '../../../../category/api/model/converter/consultationCategorySummary.converter';
import {UserSummaryConverter} from '../../../../../../account/modules/user/api/converter/userSummary.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {DateConverter} from '../../../../../../common/converter/date.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {OfficeSummaryConverter} from '../../../../../../office/api/model/converter/officeSummary.converter';


@Injectable({ providedIn: 'root' })
export class ConsultationSummaryConverter extends HttpModelConverter<ConsultationSummaryModel> {
    constructor(private consultationCategorySummaryConverter: ConsultationCategorySummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private officeSummaryConverter: OfficeSummaryConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }
    protected createInstance(): ConsultationSummaryModel {
        return new ConsultationSummaryModel();
    }

    protected enrichObject(result: ConsultationSummaryModel, src: ConsultationSummaryModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.responsible = new UserSummaryConverter().convert(src.responsible);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.date = new DateConverter().convert(src.date);
        result.category = this.consultationCategorySummaryConverter.convert(src.category);
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.office = this.officeSummaryConverter.convert(src.office);
        result.cancellationType = this.lovValueSummaryConverter.convert(src.cancellationType);
        result.mode = this.lovValueSummaryConverter.convert(src.mode);
        result.cancelledUser = this.userSummaryConverter.convert(src.cancelledUser);
    }
}
